import { TokenStatus, DocumentType, AuctionStatus, ArtistType } from '@do/models';
import type { ValuesOf } from '@do/utils/types';

const CommonStatus = {
  Draft: 'draft',
  Published: 'published',
  Verified: 'verified',
  Pending: 'pending',
  Copy: 'copy',
  Other: 'other',
  Unverified: 'unverified',
  Online: 'online',
} as const;
type CommonStatus = ValuesOf<typeof CommonStatus>;

const DeprecatedStatus = {
  ReadyForMint: 'ready_for_mint',
  MetadataUploading: 'metadata_uploading',
  MetadataUploaded: 'metadata_uploaded',
  Minting: 'minting',
  MintingFailed: 'minting_failed',
} as const;
type DeprecatedStatus = ValuesOf<typeof DeprecatedStatus>;

export const LabelKey = {
  ...TokenStatus,
  ...CommonStatus,
  ...DeprecatedStatus,
  ...DocumentType,
  ...ArtistType,
  ...AuctionStatus,
};
export type LabelKey = ValuesOf<typeof LabelKey>;
